var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dg-sidebar-frame" },
    [
      _c("dg-page-header"),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "main" }, [
            _c("div", { attrs: { id: "index" } }, [
              !_vm.hideLeftMenu
                ? _c(
                    "div",
                    {
                      staticClass: "frame-left-ali",
                      style: { width: _vm.frameWidth + "px" },
                      attrs: { id: "frame-left" },
                    },
                    [
                      _c(
                        "div",
                        {
                          attrs: { id: "indexDiv-ali" },
                          on: { click: _vm.clickIndexDiv },
                        },
                        [
                          _c("i", {
                            class: _vm.collapse
                              ? "el-icon-s-unfold"
                              : "el-icon-s-fold",
                            attrs: { id: "icon" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("dg-menu", {
                        ref: "dgMenuAliyun",
                        attrs: {
                          id: "indexMenu-ali",
                          "api-code": "sysUserMenu",
                          "text-color": "#dddddd",
                          "background-color": "#404040",
                          "title-style":
                            "height:0;padding:0;margin:0;font-size:0;",
                          root: _vm.menuRoot,
                          collapse: _vm.collapse,
                          "key-field": "MENU_CODE",
                          "pkey-field": "PARENTCODE",
                          "title-field": "NAME",
                          "query-terms": _vm.queryTerms,
                          "route-field": "URL",
                        },
                        on: { select: _vm.changeTab },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "frame-right",
                  style: { left: _vm.frameWidth + "px" },
                  attrs: { id: "frame-right" },
                },
                [
                  _vm.navShow == "true"
                    ? _c(
                        "div",
                        {
                          staticStyle: { "margin-bottom": "1px" },
                          attrs: { id: "Breadcrumb" },
                        },
                        [
                          _c("Breadcrumb"),
                          _vm._v(" "),
                          _vm.noticeShow == "true"
                            ? _c(
                                "div",
                                { attrs: { id: "public" } },
                                [_c("dg-notice")],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      style: { height: _vm.indexTabHeight },
                      attrs: { id: "indexTab" },
                    },
                    [_c("router-view")],
                    1
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }